var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedaccountinvites",
	init: init,
	uninit: uninit,
	triggers: triggers,

	refresh: refresh,
	updateList: updateList
});

function init() {
	this._who = null;
	this._list = [];
	this._who_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit() {
	this._who = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function triggers() {
	return {
		"send": send,
		"cancel": cancel,
		"reset": reset,
		"view": view
	};
}

function view(data){
	var who = data.who;
	if(who === this._who) return;
	this._who = who;
	this._group = data.group;
	this.refresh();
}

function refresh(){
	var who = this._who;
	var group = this._group;
	return this.api.manage.contacts.invite.list(who, group)
		.then(updateList.bind(this))
		.then(trackChanges.bind(this))
		.catch(console.log);
}

function updateList(data){
	this._list = data;
	this.push(data);
}

function trackChanges(){
	var who = this._who;
	var group = this._group;
	var tracker = this._who_tracker;
	if(!who) return;

	tracker.off();

	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/contacts/invite/new", handle_new_invite.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/contacts/invite/cancelled", handle_cancel_invite.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/contacts/invite/used", handle_cancel_invite.bind(this));
	} else {
		tracker.on("mqtt:u/" + who + "/contacts/invite/new", handle_new_invite.bind(this));
		tracker.on("mqtt:u/" + who + "/contacts/invite/cancelled", handle_cancel_invite.bind(this));
		tracker.on("mqtt:u/" + who + "/contacts/invite/used", handle_cancel_invite.bind(this));
	}
}

function handle_new_invite(invite){
	var current = this._list;
	var newList = current.concat(invite);
	this.updateList(newList);
}

function handle_cancel_invite(data){
	var inviteId = data._id;
	var current = this._list;
	var newList = current.filter(function(i){
		return i._id !== inviteId;
	});
	this.updateList(newList);
}

function send(data) {
  const who = this._who;
  if (!who) return;
  const group = this._group;
  const lang = data.language;
  const email = data.email || data.query;

  this.emit("usermetrics:trigger:track", "send managed account invite", {
	who
  });

  return this.api.manage.contacts.invite
    .request(who, email, lang, group)
    .then(handle_sent.bind(this))
    .then(() =>
      this.dispatch("viewing", {
        who: this._who,
        section: "contacts",
        timestamp: new Date().toISOString(),
      })
    )
    .catch(console.log);
}

function cancel(invite) {
  const who = this._who;
  const group = this._group;
  if (!who) return;

  this.emit("usermetrics:trigger:track", "cancel managed account invite", {
	who,
  });

  return this.api.manage.contacts.invite
    .cancel(who, invite._id, group)
    .then(() =>
      this.dispatch("viewing", {
        who: this._who,
        section: "contacts",
        timestamp: new Date().toISOString(),
      })
    )
    .catch(console.log);
}

function reset(){
	this._who = null;
	this._group = null;
	this._list = [];
	this.push([]);
}

function handle_sent(){
	this.dispatch("sent");
}